import { render } from "./ImageSizeModal.vue?vue&type=template&id=a6afe3d6&scoped=true"
import script from "./ImageSizeModal.vue?vue&type=script&lang=js"
export * from "./ImageSizeModal.vue?vue&type=script&lang=js"

import "./ImageSizeModal.vue?vue&type=style&index=0&id=a6afe3d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6afe3d6"]])

export default __exports__